import { format } from 'd3-format';
import { teal, defaults } from './utils/colors';

import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    colorScale,
  		data,
    initialWidth,
    initialHeight,
    width,
    height,
    x,
    y,
    xAxis,
    yAxis,
    margins,
  } = props;

  const yTicks = isMobile ? 2 : 5;
  const fmtComma = format('$,');
  const fmtSI = format('$.2s');
  const fmtSIBig = format('$.3s');

  const fedColors = {
    BARDA: '#5cb0a8',
    DARPA: '#315551',
  };

  container.append('ul')
    .attr('class', 'key')
    .selectAll('li')
    .data(['DARPA', 'BARDA'])
    .enter()
    .append('li')
    .attr('class', 'key-item')
    .html(d => `<span class='key-block key-${d}'></span> ${d}`);


  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  const xGrid = g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(${[0, height]})`)
    .call(xAxis(x)
      .tickFormat(d => (isMobile ? `\u0027${String(d).slice(2)}` : d)));

  xGrid.selectAll('text')
    .attr('y', 10);

  const yGrid = g.append('g')
    .attr('class', 'y grid')
    .call(yAxis(y)
      .ticks(yTicks)
      .tickSize(-width)
      .tickFormat(d => (isMobile
        ? (Math.abs(d) > 999
          ? fmtSI(d).toUpperCase()
          : fmtComma(d)
        )
        : (Math.abs(d) > 9999
          ? fmtSI(d).toUpperCase()
          : fmtComma(d)
        ))));

  yGrid.selectAll('text')
    .attr('x', -5)
    .filter(d => d === 0)
    .remove(); // hide zero

  const group = g.append('g')
    .attr('class', 'data');

  const bars = group.append('g')
    .attr('class', 'bars');

  const bar = bars.selectAll('.bar')
    .data(data)
    .enter().append('g')
    .attr('class', 'bar')
    .attr('role', 'list')
    .attr('transform', d => `translate(${[x(d.label), y(d.amt < 0 ? 0 : d.amt)]})`);

  bar.append('title')
    .text(d => `${d.label} ($${fmtComma(d.amt)})`);

  bar.append('rect')
    .attr('width', x.bandwidth())
    .attr('height', d => Math.abs(y(d.amt) - y(0)))
    .style('fill', d => (d.amt > 0 ? fedColors[d.category] : defaults.gray7));

  bar.append('text')
    .attr('class', 'value in')
    .attr('role', 'listitem')
    .attr('x', x.bandwidth() / 2)
    .attr('dy', d => ((d.amt > y.domain()[1] * 0.9)
      ? '1.1em'
      : '-.15em'))
    .attr('text-anchor', 'middle')
    .text(d => (isMobile
      ? (Math.abs(d.amt) > 999
        ? fmtSI(d.amt).toUpperCase()
        : fmtComma(d.amt)
      )
      : (Math.abs(d.amt) > 99999999
        ? fmtSIBig(d.amt).toUpperCase()
        : fmtSI(d.amt)
      )));

  if (y.domain()[0] < 0) {
    // zero line
    g.append('line')
      .attr('role', 'presentation')
      .attr('class', 'zero-bar')
      .attr('x1', 0)
      .attr('x2', width)
      .attr('y1', y(0))
      .attr('y2', y(0));
  }
}
